import Footer from "./Footer";

const Premios = () => {
    const premios = [
        { imagen: '/images/premios/vestidos.jpeg', name: '/images/premios/tituloVestido.png' },
        { imagen: '/images/premios/traje.jpeg', name: '/images/premios/tituloSmoking.png' },
        { imagen: '/images/premios/argollas.jpeg', name: '/images/premios/tituloArgollas.png' },
        { imagen: '/images/premios/Anillos.jpeg', name: '/images/premios/tituloAnillo.png' },
        { imagen: '/images/premios/makeup.jpeg', name: '/images/premios/tituloMake.png' },
        { imagen: '/images/premios/invitaciones.jpeg', name: '/images/premios/tituloInvitaciones.png' },
        { imagen: '/images/premios/preluna.jpeg', name: '/images/premios/tituloPre.png' },
        { imagen: '/images/premios/luna.jpeg', name: '/images/premios/tituloLuna.png' },
        { imagen: '/images/premios/Colchon.jpeg', name: '/images/premios/tituloColchon.png' },
        { imagen: '/images/premios/Electrodomesticos.jpeg', name: '/images/premios/tituloArticulos.png' },
        { imagen: '/images/premios/video.jpeg', name: '/images/premios/tituloVideo.png' },
        { imagen: '/images/premios/pastel.jpeg', name: '/images/premios/tituloPastel.png' },
        { imagen: '/images/premios/DJ.jpeg', name: '/images/premios/tituloDJ.png' },
        { imagen: '/images/premios/arreglos.jpeg', name: '/images/premios/tituloArreglo.png' },
        { imagen: '/images/premios/salon.jpeg', name: '/images/premios/tituloSalon.png' },
        { imagen: '/images/premios/comida.jpeg', name: '/images/premios/tituloBanquete.png' },
    ]


    return (
        <>
            <div className="bg-premios">
                <div className="container">
                    <div className="container text-center">
                        <h1 className="pt-5 mb-3 titulosPremios">Premios</h1>
                        <p className="textoPremios">Ya saben que todo me gusta de <strong>PRIMERA</strong> y en <strong>ABUNDANCIA,</strong> por eso para que tengan la mejor
                            boda del 2023, tenemos listo desde el <strong>VESTIDO</strong> hasta la <strong>LUNA DE MIEL</strong>, más todos estos regalos.
                        </p>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div id="carouselExampleIndicators" className="carousel slide text-center" >
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <img src={process.env.PUBLIC_URL + "/images/premios/vestidos.jpeg"} className="circuloPremios" />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + "/images/premios/tituloVestido.png"} className="TituloImagenes" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/traje.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloSmoking.png'} className="TituloImagenEsmoquin" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/argollas.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloArgollas.png'} className="TituloImagenArgollas" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/Anillos.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloAnillo.png'} className="TituloImagenAnillos" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/makeup.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloMake.png'} className="TituloImagenMake" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/invitaciones.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloInvitaciones.png'} className="TituloImagenInvitacion" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/luna.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloLuna.png'} className="TituloImagenLuna" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>

                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/Electrodomesticos.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloArticulos.png'} className="TituloImagenArticulo" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/video.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloVideo.png'} className="TituloImagenVideo" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/pastel.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloPastel.png'} className="TituloImagenPastel" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/DJ.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloDJ.png'} className="TituloImagenDJ" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/arreglos.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloArreglo.png'} className="TituloImagenArreglos" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/salon.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloSalon.png'} className="TituloImagenSalon" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                    <div className="carousel-item ">
                                        <img src={process.env.PUBLIC_URL + '/images/premios/comida.jpeg'} className="circuloPremios " />
                                        <div className="containerPremio mx-auto">
                                            <img src={process.env.PUBLIC_URL + '/images/premios/tituloBanquete.png'} className="TituloImagenBanquete" />
                                        </div>
                                        <p className="titulosMon mb-5">#CASATECONMARTHA</p>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="container mb-5">
                        <div className='row text-center'>
                            <div className='col-12'>
                                <h5 className='letter-space'>PATROCINADO POR:</h5>
                            </div>
                            <div className='mx-auto col-md-4 mb-2'>
                                <a href='https://www.visitcostarica.com/es/mexico' target='_blank'><img className='costa' src={process.env.PUBLIC_URL + "/images/1- LOGO COSTA RICA.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mb-3'>
                                <a href='https://mesaderegalos.liverpool.com.mx' target='_blank'><img className='mesas' src={process.env.PUBLIC_URL + "/images/logo_mesa.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mb-3'>
                                <a href='https://www.cts.com.mx' target='_blank'><img className='CTS' src={process.env.PUBLIC_URL + "/images/logo_cst.png"} /></a>
                            </div>
                        </div>
                        <div className='row text-center'>
                            <div className='mx-auto col-md-4 mb-2'>
                                <a href='https://www.liverpool.com.mx/tienda/home' target='_blank'><img className='liverpool' src={process.env.PUBLIC_URL + "/images/logo_Liverpool.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mb-2'>
                                <a href='https://sposabella.mx/' target='_blank'><img className='liverpool' src={process.env.PUBLIC_URL + "/images/logo_Sposa.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mb-2 mt-3'>
                                <a href='https://socasesores.com/' target='_blank'><img className='soc' src={process.env.PUBLIC_URL + "/images/logos/Logo_Soc.png"} /></a>
                            </div>
                        </div>
                        <div className='row text-center'>
                            <div className='mx-auto col-md-4 mb-2'>
                                <a href='https://mauriciorenteria.com' target='_blank'><img className='liverpool' src={process.env.PUBLIC_URL + "/images/logos/MAURICIO RENTERIA LOGO.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mb-2'>
                                <a href='https://www.recordartefilms.com' target='_blank'><img className='liverpool' src={process.env.PUBLIC_URL + "/images/logos/RECORDARTE FILMS LOGO.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mb-2'>
                                <a href='https://www.silviagalvan.com' target='_blank'><img className='liverpool m-3' src={process.env.PUBLIC_URL + "/images/logos/Silvia Galvan Image Studio Logo.png"} /></a>
                            </div>
                        </div>
                        <div className='row text-center'>
                            <div className='mx-auto col-md-4 mb-2'>
                                <a href='https://jdjoyeros.com' target='_blank'><img className='joyeros' src={process.env.PUBLIC_URL + "/images/logos/JD JOYEROS LOGO2_0_5x.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mb-2'>
                                <a href='https://sacher.com.mx' target='_blank'><img className='joyeros' src={process.env.PUBLIC_URL + "/images/logos/L´AUTRICHIENNE LOGO_0_5x.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mb-2'>
                                <a href='https://floresmeyer.com.mx' target='_blank'><img className='Floresmeyer' src={process.env.PUBLIC_URL + "/images/logos/Floresmeyer.png"} /></a>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='mx-auto col-md-4 mb-2 text-center'>
                                <a href='https://www.loreal-paris.com.mx' target='_blank'><img className='loreal' src={process.env.PUBLIC_URL + "/images/logos/LOGO_LOREAL.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mb-2 text-center'>
                                <a href='https://chefman.com.mx/' target='_blank'><img className='loreal' src={process.env.PUBLIC_URL + "/images/logos/LOGO_CHEFMAN.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mb-2 text-center'>
                                <a href='https://tienda.prudence.com.mx/' target='_blank'><img className='prudence' src={process.env.PUBLIC_URL + "/images/logos/Logo_P.png"} /></a>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='mx-auto col-md-4 mb-2'>
                                <a href='https://www.yakult.com.mx' target='_blank'><img className='loreal' src={process.env.PUBLIC_URL + "/images/logos/logo_Yakult.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mt-3 text-center '>
                                <a href='https://www.dpaul.mx' target='_blank'><img className='liverpool m-3' src={process.env.PUBLIC_URL + "/images/logos/D PAUL LOGO.png"} /></a>
                            </div>
                            <div className='mx-auto col-md-4 mt-3 text-center '>
                                <a href='https://www.comex.com.mx/' target='_blank'><img className='liverpool m-3' src={process.env.PUBLIC_URL + "/images/logos/Logo Comex.png"} /></a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default Premios;